import {
  Grid,
  TextField,
  Button,
  Checkbox,
  Switch,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import { Autocomplete } from "@material-ui/lab";
import { useSelector } from "react-redux";
import Call from "../../service/API";
import { useDispatch } from "react-redux";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { useMountAPI } from "../../hooks/APICall";
import {
  SetUsers,
  UpdateUsersList,
  SetCounterTypes,
  UpdateCounterTypes,
  SetProjects,
  UpdateProjectsList,
  UpdateCountersList,
} from "../../store/actions";
import { useEffect } from "react";
import { useHistory } from "react-router";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const AddCounter = (props) => {
  const expanded = useCustomState(false);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const pureUsers = useSelector((state) => state.users);
  const pureCounterTypes = useSelector((state) => state.counterTypes);
  const pureProjects = useSelector((state) => state.projects);

  const dispatch = useDispatch();

  const counterName = useCustomState("");
  const serialNumber = useCustomState("");
  const counterCategory = useCustomState({ title: "", id: -1 });
  const counterType = useCustomState({ title: "", id: -1 });
  const counterDescription = useCustomState("");

  const counterNameError = useCustomState({ error: false, text: "" });
  const serialNumberError = useCustomState({ error: false, text: "" });
  const counterCategoryError = useCustomState({ error: false, text: "" });
  const CounterTypeError = useCustomState({ error: false, text: "" });
  const reciveOrder = useCustomState(false);
  const orderTypeState = useCustomState("");
  const counterNameChanged = (e) => {
    counterNameError.handleChange({ error: false, text: "" });
    counterName.handleChange(e.target.value);
  };

  const serialNumberChanged = (e) => {
    serialNumberError.handleChange({ error: false, text: "" });
    serialNumber.handleChange(e.target.value);
  };
  const counterCategoryChanged = (e, newValue) => {
    counterCategoryError.handleChange({ error: false, text: "" });
    counterCategory.handleChange(newValue);
  };

  const counterTypeChanged = (e, newValue) => {
    CounterTypeError.handleChange({ error: false, text: "" });
    counterType.handleChange(newValue);
  };
  const counterDescriptionChanged = (e) => {
    counterDescription.handleChange(e.target.value);
  };

  const history = useHistory();

  // const usersIsLoading = useCustomState(true);
  const counterTypesIsLoading = useCustomState(true);

  const counterTypesUtils = {
    page: 1,
    count: 200,
    typeName: "",
    typeDate: "",
    isLoading: counterTypesIsLoading,
    dispatch: dispatch,
    history: history,
  };
  useMountAPI(fetchCounterTypes, counterTypesUtils);
  const counterTypes = useCustomState([]);
  const counterCategories = [
    { title: "", id: -1 },
    { title: "آب", id: "07d00e58-a3a4-4963-9f25-d22d4a5befbd" },
    { title: "برق", id: "ac32c39a-c371-4936-a802-37ead17f8301" },
    { title: "گاز", id: "3d5fd998-2637-4a61-a469-4bb344417cc5" },
    { title: "سایر", id: "4f7205f0-c8a7-4fb1-a450-0c6622d4f364" },
  ];

  // useEffect(() => {
  //   if (!usersIsLoading.value) {
  //     users.handleChange(processUsers(pureUsers));
  //   }
  // }, [usersIsLoading.value]);

  useEffect(() => {
    if (!counterTypesIsLoading.value) {
      counterTypes.handleChange(processCounterTypes(pureCounterTypes));
    }
  }, [counterTypesIsLoading.value]);

  // useEffect(() => {
  //   if (!projectsIsLoading.value) {
  //     projects.handleChange(processProjects(pureProjects));
  //   }
  // }, [projectsIsLoading.value]);

  const addCounter = (e) => {
    const name = counterName.value;
    const serial = serialNumber.value;
    const userId = null;
    const tag = counterCategory.value.title;
    const type = counterType.value.id;
    const project = null;
    const isActive = 0;
    const isValid = 0;
    const canReceiveCommand = reciveOrder.value ? 1 : 0;
    let description = counterDescription.value;
    const orderType = orderTypeState.value;
    const module = null;
    const admin = null;

    let hasError = false;

    if (name.length == 0) {
      counterNameError.handleChange({
        error: true,
        text: "واردکردن نام کنتور الزامی است.",
      });
      hasError = true;
    }
    if (serial.length == 0) {
      serialNumberError.handleChange({
        error: true,
        text: "واردکردن شماره سریال کنتور ازامی است.",
      });
      hasError = true;
    }
    if (tag.length == 0) {
      counterCategoryError.handleChange({
        error: true,
        text: "انتخاب دسته کنتور الزامی است.",
      });
      hasError = true;
    }
    if (type.length == 0 || type == -1) {
      CounterTypeError.handleChange({
        error: true,
        text: "انتخاب نوع کنتور الزمی است.",
      });
      hasError = true;
    }
    if (description.length == 0) {
      description = "وارد نشده";
    }
    // ----------------------------------------------------------------------------------------------------
    if (hasError) {
      return;
    }
    // ---------------------------------------------------------------------------------------------------------
    const data = {
      water_meter_user_id: userId,
      water_meter_name: name,
      water_meter_tag: tag,
      water_meter_serial: serial,
      water_meter_location: "lat:0",
      other_information: {
        description: description,
      },
      water_meter_validation: isValid,
      water_meter_activation: isActive,
      water_meter_condition: canReceiveCommand,
      water_meter_type: type,
      water_meter_project: project,
      water_meter_module: module,
      water_meter_order_mode: reciveOrder.value ? orderType : null,
    };
    Call("POST", "watermeters/admin/create", data)
      .then((response) => {
        if (response.data.code === 200) {
          dispatch(UpdateCountersList({ updateCountersList: true }));
          counterName.handleChange("");
          serialNumber.handleChange("");
          counterCategory.handleChange({ title: "", id: -1 });
          counterType.handleChange({ title: "", id: -1 });
          counterDescription.handleChange("");
          reciveOrder.handleChange(false);
          orderTypeState.handleChange("");
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
        }
      });
  };

  return (
    <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Card style={{ width: "100%", marginTop: "16px" }}>
          <CardHeader
            style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
            title={"افزودن کنتور جدید"}
            action={
              <ExpandMoree
                expand={expanded.value}
                onClick={handleExpandClick}
                aria-expanded={expanded.value}
                aria-label="show more"
              >
                <ExpandMore />
              </ExpandMoree>
            }
          />
          <Collapse in={expanded.value} timeout="auto" unmountOnExit>
            <CardContent
              style={{
                padding: "16px",
                // maxHeight: "320px",
                overflow: "scroll",
              }}
            >
              <Grid
                container
                style={{ paddingTop: "24px", paddingBottom: "24px" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={counterNameError.value.error}
                    helperText={counterNameError.value.text}
                    onChange={counterNameChanged}
                    value={counterName.value}
                    fullWidth
                    variant="standard"
                    label="نام کنتور"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={serialNumberError.value.error}
                    helperText={serialNumberError.value.text}
                    onChange={serialNumberChanged}
                    value={serialNumber.value}
                    fullWidth
                    variant="standard"
                    label="شماره سریال"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Autocomplete
                    onChange={counterCategoryChanged}
                    value={counterCategory.value}
                    options={counterCategories}
                    getOptionLabel={(option) => option.title}
                    id="disable-close-on-select"
                    renderInput={(params) => (
                      <TextField
                        error={counterCategoryError.value.error}
                        helperText={counterCategoryError.value.text}
                        {...params}
                        label="دسته کنتور"
                        variant="standard"
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Autocomplete
                    onChange={counterTypeChanged}
                    value={counterType.value}
                    options={counterTypes.value}
                    getOptionLabel={(option) => option.title}
                    id="disable-close-on-select"
                    // disableCloseOnSelect
                    renderInput={(params) => (
                      <TextField
                        error={CounterTypeError.value.error}
                        helperText={CounterTypeError.value.text}
                        {...params}
                        label="نوع کنتور"
                        variant="standard"
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginBottom: "8px",
                    alignSelf: "end",
                  }}
                >
                  {"قابلیت فرمان پذیری : "}
                  {""}
                  <Switch
                    checked={reciveOrder.value}
                    onChange={(e) => reciveOrder.handleChange(e.target.checked)}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <FormControl fullWidth sx={{ m: 1, minWidth: 80 }}>
                    <InputLabel id="select-project-label">
                      نوع فرمان{" "}
                    </InputLabel>
                    <Select
                      labelId="select-project-label"
                      id="select-project"
                      value={orderTypeState.value}
                      fullWidth
                      label="نوع فرمان"
                      onChange={(e) =>
                        orderTypeState.handleChange(e.target.value)
                      }
                      disabled={!reciveOrder.value}
                    >
                      <MenuItem value="R">
                        <em>زنده (منبع تغذیه برق)</em>
                      </MenuItem>
                      <MenuItem value="P">
                        <em>زمان دار (منبع تغذیه باطری)</em>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    onChange={counterDescriptionChanged}
                    value={counterDescription.value}
                    fullWidth
                    variant="filled"
                    label="توضیحات کنتور"
                    multiline
                    rows={8}
                    maxRows={12}
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Button
                    onClick={addCounter}
                    style={{ color: "#fff" }}
                    variant="contained"
                    color="primary"
                  >
                    افزودن
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Collapse>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AddCounter;

const processUsers = (users) => {
  const results = [{ title: "", id: -1 }];
  let data;
  users.map((user) => {
    data = {
      title: user.user_name + " " + user.user_lastname,
      id: user.user_id,
    };
    results.push(data);
  });
  return results;
};

const processCounterTypes = (counterTypes) => {
  const results = [{ title: "", id: -1 }];
  let data;
  counterTypes.map((counterType) => {
    data = {
      title: counterType.water_meter_type_name,
      id: counterType.water_meter_type_id,
    };
    results.push(data);
  });
  return results;
};

const processProjects = (projects) => {
  const results = [{ title: "", id: -1 }];
  let data;
  projects.map((project) => {
    data = {
      title: project.water_meter_project_name,
      id: project.water_meter_project_id,
    };
    results.push(data);
  });
  return results;
};

const fetchUsers = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const username = utils.username;
  const lastname = utils.lastname;
  const phoneNumber = utils.phoneNumber;
  const dispatch = utils.dispatch;
  const isLoading = utils.isLoading;

  const data = {
    page: page,
    count: count,
    user_name: username,
    user_lastname: lastname,
    user_phone: phoneNumber,
  };

  Call("POST", "users/admin/getAllUsers", data)
    .then((response) => {
      // console.log("users", response);
      if (response.data.code == 200) {
        const users = response.data.data.users;
        dispatch(SetUsers(users));
        dispatch(UpdateUsersList({ updateUsersList: false }));
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
    });
};

const fetchCounterTypes = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const typeName = utils.typeName;
  const typeDate = utils.typeDate;
  const isLoading = utils.isLoading;
  const dispatch = utils.dispatch;
  const history = utils.history;

  const data = {
    page: page,
    count: count,
    water_meter_type_name: typeName,
    water_meter_type_create_date: typeDate,
  };

  Call("POST", "WaterMeterTypes/admin/getAll", data)
    .then((response) => {
      // console.log("counterTypes", response);
      if (response.data.code == 200) {
        dispatch(SetCounterTypes(response.data.data.results));
        dispatch(UpdateCounterTypes({ updateCounterTypes: false }));
      }
      // console.log(response);
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code == 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};

const fetchprojectsList = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const projectNameFilter = utils.projectNameFilter;
  const projectCreateDateFilter = utils.projectCreateDateFilter;
  const isLoading = utils.isLoading;
  const dispatch = utils.dispatch;

  const data = {
    page: page,
    count: count,
    water_meter_project_name: projectNameFilter,
    water_meter_project_create_date: projectCreateDateFilter,
  };
  Call("POST", "WaterMeterProjectsURL/admin/getAll", data)
    .then((response) => {
      // console.log("projects", response);
      if (response.data.code == 200) {
        const ps = response.data.data;
        dispatch(SetProjects(ps));
        dispatch(UpdateProjectsList({ updateProjectsList: false }));
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      // console.log(error);
      isLoading.handleChange(false);
    });
};
